import { CreateVehiclePayload } from 'amqp-contracts';

export type CrmVehiclePostRequestDto = CreateVehiclePayload;
